import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    CreateContractMessage,
    getContractPriceLists,
    getContract,
    getContracts,
    GetContractsParams,
    validateContract,
} from '../clients/contracts.api';

export const contracts = createQueryKeys('contracts', {
    pagination: (params: GetContractsParams) => ({
        queryKey: [params],
        queryFn: () => getContracts(params),
    }),
    comboBoxOptions: (params: GetContractsParams) => ({
        queryKey: [params],
    }),
    selectedComboBoxOption: (contractId: string) => ({
        queryKey: [contractId],
    }),
    detail: (id: string) => ({
        queryKey: [{ id }],
        queryFn: () => getContract(id),
        contextQueries: {
            priceLists: {
                queryKey: null,
                queryFn: () => getContractPriceLists(id),
            },
            validation: (contract: CreateContractMessage) => ({
                queryKey: [contract],
                queryFn: () => validateContract(contract),
            }),
        },
    }),
});
